import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import useEventBookingSession from 'features/Events/hooks/useEventBookingSession';
import { SkeletonLineSlim } from 'components/theme/Skeleton/Skeleton';
import { getFormattedTimes } from 'utils/session';
import { useGlobalDateLocale } from 'context/DateLocaleContext';

const EventLocation = () => {
  const { listing } = useEventBookingSession();
  const { t: translate } = useTranslation();
  const { locale } = useGlobalDateLocale();

  return (
    <Wrapper>
      <Where className="activate-location-where">
        <Title as="h3" className="activate-location-title">
          {translate('location')}
        </Title>
        <Label className="activate-location-label">
          {listing ? listing.location?.name : <SkeletonLineSlim />}
        </Label>
        {listing?.location?.additionalInfo && (
          <Label>{listing.location.additionalInfo}</Label>
        )}
      </Where>
      <When className="activate-time-when">
        <Title as="h3" className="activate-time-title">
          {translate('time')}
        </Title>
        <Label className="activate-time-label">
          {listing?.eventStartTimes ? (
            getFormattedTimes(listing.eventStartTimes, locale)
          ) : (
            <SkeletonLineSlim />
          )}
        </Label>
      </When>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  padding: 48px 0px;
  border-bottom: solid 0.5px var(--way-colors-borderColor);
  display: flex;
  gap: 24px;
`;

const Where = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 8px;
`;
const When = styled(Where)``;

const Title = styled.span`
  color: var(--way-colors-primaryTextColor);
  font-weight: bold;
  margin: 0;
`;

const Label = styled.span`
  color: ${({ theme }) => `${theme.colors.primaryTextColor}99`};
`;

export default EventLocation;
